import { NgcCookieConsentConfig } from 'ngx-cookieconsent';

export const COOKIE_CONFIG: NgcCookieConsentConfig = {
  cookie: {
    domain: 'window.location.hostname', // or 'your.domain.com'
  },
  position: 'bottom-left',
  theme: 'edgeless',
  palette: {
    popup: {
      background: '#000',
    },
    button: {
      background: '#f1d600',
    },
  },
  type: 'opt-in',
  layout: 'gtnLayout',
  layouts: {
    gtnLayout: '{{messagelink}}{{compliance}}',
  },
  elements: {
    messagelink: `
      <div id="cookieconsent:desc" class="cc-message">
       {{message}}
        <p>
             Nella pagina della Informativa Estesa che può consultare all'indirizzo <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{cookiePolicyHref}}" target="_blank">{{cookiePolicyLink}}</a> sono presenti le istruzioni per negare il consenso all'installazione di qualunque cookie.
             Cliccando su "ACCETTA" o continuando la navigazione, saranno attivati tutti i cookie specificati nell'Informativa Estesa ai sensi degli artt. 13 e 14 Reg.to UE 2016/679.
        </p>
     </div>
    `,
  },
  content: {
    header: 'Cookie utilizzati nel sito web!',
    message: `
      <p>
        La informiamo che, per migliorare la sua esperienza di navigazione su questo sito web,
        Gattinoni Travel Network S.r.l. utilizza diversi tipi di cookie, tra cui:
      </p>
      <p>cookie di tipo funzionale alla navigazione (functionality cookie)</p>
      <ul class="list-group">
        <li class="list-group-item">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="cookieAdvertising" id="cookieAdvertising">
            <label class="form-check-label" for="cookieAdvertising">
                cookie di tipo pubblicitario (advertising cookie)
            </label>
          </div>
        </li>
        <li class="list-group-item">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="cookiePerformance" id="cookiePerformance">
              <label class="form-check-label" for="cookiePerformance">
                  cookie di tipo statistico (performance cookie)
              </label>
          </div>
        </li>
      </ul>
      <p>che consentono di accedere a dati personali raccolti durante la navigazione.</p>
    `,
    dismiss: 'ACCETTA',
    allow: 'ACCETTA',
    deny: 'RIFIUTA I COOKIE',
    link: 'Scopri di più',
    href: '/privacy-policy',
    policy: 'Politica sui cookie',
    cookiePolicyLink: 'https://www.privacylab.it/informativa.php?19637433905',
    cookiePolicyHref: 'https://www.privacylab.it/informativa.php?19637433905',
  },
};
